import actions from './actions'
import mutations from './mutations'
const state = {
  type: 0,   //1常旅客礼包   0抢票包
  isSelected: true,
  isNative: false
}
export default {
  namespaced: true,
  actions,
  state,
  mutations
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/goldSale/store/index.js